import { useState, useEffect } from "react";
import { useFirestore } from "../../hooks/useFirestore";
import data from "../../EE_courses.json";
import { MdDeleteForever } from "react-icons/md";
import { Button, Card, Col, Container, Form, Modal, Row } from "react-bootstrap";
import coursesData from '../../EE_courses.json';


export default function StudentForm({ uid , student, portalIsOpen}) {
  const [subject1, setSubject1] = useState("");
  const [subject2, setSubject2] = useState("");
  const [subject3, setSubject3] = useState("");
  const [subject4, setSubject4] = useState("");
  const [subject5, setSubject5] = useState("");
  const [subject6, setSubject6] = useState("");
  const [subject7, setSubject7] = useState("");
  const [subject8, setSubject8] = useState("");
  const [notes, setNotes] = useState("");
  const [finalSubjects, setFinalSubjects] = useState([]);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirm, setConfirm] = useState(false)
  const [conflictError, setConflictError] = useState([]);
  const [corequisiteError, setCorequisiteError] = useState([]);
  const [prerequisiteError, setPrerequisiteError] = useState([]);




  const documents = data;
  const { updateDocument, response } = useFirestore("students");
  
  const checkPrerequisitesAndCorequisites = (selectedSubjects) => {
    let errors = [];
  
    selectedSubjects.forEach(courseId => {
      const course = coursesData.find(c => c.course_id === courseId);
  
      // Check prerequisites
      if (course?.prerequisite) {
        course.prerequisite.forEach(prerequisite => {
          if (!student?.[0]?.passed_subjects?.includes(prerequisite)) {
            if (selectedSubjects.includes(prerequisite) || student?.[0]?.failed_subjects?.includes(prerequisite)) {
              errors.push(`لم يتم استيفاء متطلبات ${course.course_title} الأساسية: ${prerequisite}`);
            }
          }
        });
      }
  
      // Check corequisites
      if (course?.corequisite) {
        course.corequisite.forEach(corequisite => {
          if (!selectedSubjects.includes(corequisite) && !student?.[0]?.passed_subjects?.includes(corequisite)) {
            errors.push(`لم يتم استيفاء المتطلبات المشتركة لـ ${course.course_title}: ${corequisite}`);
          }
        });
      }
    });
  
    return errors;
  };
  


  // const checkForConflicts = (selectedSubjects) => {
  //   let conflicts = [];
  
  //   midtermsTimetable.forEach(entry => {
  //     const overlap = entry.courses.filter(course => selectedSubjects.includes(course));
  //     console.log('overlap', overlap);
  
  //     // Add the group of conflicting courses only if there's an actual conflict (more than one course in the same slot)
  //     if (overlap.length > 1) {
  //       conflicts.push(overlap);
  //     }
  //   });
    
  //   // Flattening and removing duplicates if necessary
  //   return [...new Set(conflicts.flat())];
  // };

 
  useEffect(() => {
    // Parse failed subjects from the student object
    const failedSubjects = student?.[0]?.failed_subjects ? student[0].failed_subjects : [];
  
    // Set up to 8 failed subjects to the state variables
    [setSubject1, setSubject2, setSubject3, setSubject4, setSubject5, setSubject6, setSubject7, setSubject8]
      .forEach((setSubject, index) => {
        if (failedSubjects[index]) {
          setSubject(failedSubjects[index]);
        }
      });
  }, [student]);
  const handleSubmit = (e) => {
    e.preventDefault();
  
    // Clear previous errors
    setPrerequisiteError([]);
    setCorequisiteError([]);
  
    const failedSubjects = student?.[0]?.failed_subjects || [];
    const selectedSubjects = [
      subject1, subject2, subject3, subject4, 
      subject5, subject6, subject7, subject8
    ].filter(subject => subject && !failedSubjects.includes(subject));

    const mergedSubjects = [...new Set([...selectedSubjects, ...failedSubjects])];

  
    // Check for prerequisites and corequisites
    const errors = checkPrerequisitesAndCorequisites(mergedSubjects);
    
    if (errors.length > 0) {
      const prerequisiteErrors = errors.filter(e => e.includes('متطلبات'));
      const corequisiteErrors = errors.filter(e => e.includes('المتطلبات المشتركة'));
  
      if (prerequisiteErrors.length > 0) {
        setPrerequisiteError(prerequisiteErrors);
      }
  
      if (corequisiteErrors.length > 0) {
        setCorequisiteError(corequisiteErrors);
      }
  
      return; // Stop the submission if there are errors
    }
  
    // Proceed with form submission if there are no errors
    setFinalSubjects(mergedSubjects);
    setConfirmationModal(true);
  };

  useEffect(() => {
    if (confirm) {
      updateDocument(uid, { new_subjects: finalSubjects, notesToSupervisor: notes });
      // You may also reset confirm here if needed
 
    }
  }, [confirm, finalSubjects, uid, notes]);


  useEffect(() => {
    setPrerequisiteError([]);
    setCorequisiteError([]);
  }, [subject1, subject2, subject3, subject4, subject5, subject6, subject7, subject8]);

  // reset the form fields
  useEffect(() => {
    if (response.success) {
      setSubject1("");
      setSubject2("");
      setSubject3("");
      setSubject4("");
      setSubject5("");
      setSubject6("");
      setSubject7("");
      setSubject8("");
    }
  }, [response.success]);


  return (
    <>
   {prerequisiteError.length > 0 && (
        <div className="alert alert-danger" role="alert">
          {prerequisiteError.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
        </div>
      )}

      {corequisiteError.length > 0 && (
        <div className="alert alert-danger" role="alert">
          {corequisiteError.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
        </div>
      )}
    <Card className="student-form" style={{marginBottom: '2.5rem'}}>
      <Card.Body>
          <Form onSubmit={handleSubmit}>
        <div className="form-group ">
          <Row className="d-flex "> 
            <Col sm={9} xs={9} md={10}>
          <label style={{ marginBottom: "12px", color:"white" }} htmlFor="subject1">
            المقرر الاول
          </label>
          <select
            style={{ marginBottom: "10px" }}
            className="form-control"
            id="subject1"
            onChange={(e) => setSubject1(e.target.value)}
            value={subject1}
            disabled={student?.[0]?.failed_subjects?.includes(subject1)}
            
          >
            <option value="">-- اختر المادة --</option>
            {documents
              ?.filter((course) => course.course_id !== subject2) // NOT SURE
              .map((course) => {
                return (
                  <>
                    <option key={course.course_id} value={course.course_id}>
                      {" "}
                      {course.course_title} | {course.course_id}
                    </option>
                  </>
                );
              })}
          </select>
          </Col>
          <Col sm={3} xs={3} md={2}  style={{margin:' auto', marginTop: '41px'}} >
          {subject1 && !student?.[0]?.failed_subjects?.includes(subject1) && (
                <Button className="w-100" onClick={() => setSubject1("")} size="sm" variant="danger"> 
                    <MdDeleteForever/>  
                </Button>
            )}

          </Col>
          </Row>
        </div>

        <div className="form-group">
          <Row className="d-flex"> 
            <Col sm={9} xs={9} md={10}> 
          <label style={{ marginBottom: "12px", color:"white" }} htmlFor="subject2">
            المقرر الثاني
          </label>
          <select
            style={{ marginBottom: "10px" }}
            className="form-control"
            id="subject2"
            onChange={(e) => setSubject2(e.target.value)}
            value={subject2}
            disabled={student?.[0]?.failed_subjects?.includes(subject2)}
          >
            <option value="">-- اختر المادة --</option>
            {documents
              ?.filter((course) => course.course_id !== subject1)
              .map((course) => {
                return (
                  <option key={course.course_id} value={course.course_id}>
                    {" "}
                    {course.course_title} | {course.course_id}{" "}
                  </option>
                );
              })}{" "}
          </select>
          </Col>
          <Col sm={3} xs={3} md={2}  style={{margin:' auto', marginTop: '41px'}}> 
          {subject2 && !student?.[0]?.failed_subjects?.includes(subject2) && (
                <Button className="w-100" onClick={() => setSubject2("")} size="sm" variant="danger"> 
                    <MdDeleteForever/>  
                </Button>
            )}
          </Col>
          </Row>
        </div>
        <div className="form-group">
          <Row className="d-flex"> 
            <Col sm={9} xs={9} md={10} >
          <label style={{ marginBottom: "12px", color:"white" }} htmlFor="subject3">
            المقرر الثالث
          </label>
          <select
            style={{ marginBottom: "10px" }}
            className="form-control"
            id="subject3"
            onChange={(e) => setSubject3(e.target.value)}
            value={subject3}
          >
            <option value="">-- اختر المادة --</option>
            {documents
              ?.filter(
                (course) =>
                  course.course_id !== subject1 && course.course_id !== subject2
              )
              .map((course) => {
                return (
                  <option key={course.course_id} value={course.course_id}>
                    {course.course_title} | {course.course_id}
                  </option>
                );
              })}
          </select>
          </Col>
          <Col sm={3} xs={3} md={2}   style={{margin:' auto', marginTop: '41px'}}> 
          {subject3 && !student?.[0]?.failed_subjects?.includes(subject3) && (
                <Button className="w-100" onClick={() => setSubject3("")} size="sm" variant="danger"> 
                    <MdDeleteForever/>  
                </Button>
            )}
          </Col>
          </Row>
        </div>

        <div className="form-group">
          <Row className="d-flex"> 
            <Col sm={9} xs={9} md={10}> 
          <label style={{ marginBottom: "12px", color:"white" }} htmlFor="subject4">
            المقرر الرابع
          </label>
          <select
            style={{ marginBottom: "10px" }}
            className="form-control"
            id="subject4"
            onChange={(e) => setSubject4(e.target.value)}
            value={subject4}
          >
            <option value="">-- اختر المادة --</option>
            {documents
              ?.filter(
                (course) =>
                  course.course_id !== subject1 &&
                  course.course_id !== subject2 &&
                  course.course_id !== subject3
              )
              .map((course) => {
                return (
                  <option key={course.course_id} value={course.course_id}>
                    {course.course_title} | {course.course_id}
                  </option>
                );
              })}
          </select>
          </Col>
          <Col sm={3} xs={3} md={2} style={{margin:' auto', marginTop: '41px'}}>
          {subject4 && !student?.[0]?.failed_subjects?.includes(subject4) && (
                <Button className="w-100" onClick={() => setSubject4("")} size="sm" variant="danger"> 
                    <MdDeleteForever/>  
                </Button>
            )}
          </Col>
          </Row>
        </div>

        <div className="form-group">
          <Row className="d-flex"> 
            <Col sm={9} xs={9} md={10}> 
          <label style={{ marginBottom: "12px", color:"white" }} htmlFor="subject4">
            المقرر الخامس
          </label>
          <select
            style={{ marginBottom: "10px" }}
            className="form-control"
            id="subject5"
            onChange={(e) => setSubject5(e.target.value)}
            value={subject5}
          >
            <option value="">-- اختر المادة --</option>
            {documents
              ?.filter(
                (course) =>
                  course.course_id !== subject1 &&
                  course.course_id !== subject2 &&
                  course.course_id !== subject3 &&
                  course.course_id !== subject4
              )
              .map((course) => {
                return (
                  <option key={course.course_id} value={course.course_id}>
                    {course.course_title} | {course.course_id}
                  </option>
                );
              })}
          </select>
          </Col>
          <Col xs={3} sm={3} md={2} style={{margin:' auto', marginTop: '41px'}}>
          {subject5 && !student?.[0]?.failed_subjects?.includes(subject5) && (
                <Button className="w-100" onClick={() => setSubject5("")} size="sm" variant="danger"> 
                    <MdDeleteForever/>  
                </Button>
            )}
          </Col>
          </Row>
        </div>

        <div className="form-group">
          <Row className="d-flex"> 
            <Col xs={9} sm={9} md={10}> 
          <label style={{ marginBottom: "12px", color:"white" }} htmlFor="subject4">
            المقرر السادس
          </label>
          <select
            style={{ marginBottom: "10px" }}
            className="form-control"
            id="subject6"
            onChange={(e) => setSubject6(e.target.value)}
            value={subject6}
          >
            <option value="">-- اختر المادة --</option>
            {documents
              ?.filter(
                (course) =>
                  course.course_id !== subject1 &&
                  course.course_id !== subject2 &&
                  course.course_id !== subject3 &&
                  course.course_id !== subject4 &&
                  course.course_id !== subject5
              )
              .map((course) => {
                return (
                  <option key={course.course_id} value={course.course_id}>
                    {course.course_title} | {course.course_id}
                  </option>
                );
              })}
          </select>
          </Col>
          <Col xs={3} sm={3} md={2} style={{margin:' auto', marginTop: '41px'}}>
          {subject6 && !student?.[0]?.failed_subjects?.includes(subject6) && (
                <Button className="w-100" onClick={() => setSubject6("")} size="sm" variant="danger"> 
                    <MdDeleteForever/>  
                </Button>
            )}
          </Col>
          </Row>
        </div>
        <div className="form-group">
          <Row className="d-flex"> 
            <Col sm={9} xs={9} md={10}> 
          <label style={{ marginBottom: "12px", color:"white" }} htmlFor="subject4">
            المقرر السابع
          </label>
          <select
            style={{ marginBottom: "10px" }}
            className="form-control"
            id="subject7"
            onChange={(e) => setSubject7(e.target.value)}
            value={subject7}
          >
            <option value="">-- اختر المادة --</option>
            {documents
              ?.filter(
                (course) =>
                  course.course_id !== subject1 &&
                  course.course_id !== subject2 &&
                  course.course_id !== subject3 &&
                  course.course_id !== subject4 &&
                  course.course_id !== subject5 &&
                  course.course_id !== subject6
              )
              .map((course) => {
                return (
                  <option key={course.course_id} value={course.course_id}>
                    {course.course_title} | {course.course_id}
                  </option>
                );
              })}
          </select>
          </Col>
          <Col sm={3} xs={3} md={2} style={{margin:' auto', marginTop: '41px'}}>
          {subject7 && !student?.[0]?.failed_subjects?.includes(subject7) && (
                <Button className="w-100" onClick={() => setSubject7("")} size="sm" variant="danger"> 
                    <MdDeleteForever/>  
                </Button>
            )}
          </Col>
          </Row>
        </div>

        <div className="form-group">
          <Row className="d-flex"> 
            <Col sm={9} xs={9} md={10}> 
          <label style={{ marginBottom: "12px", color:"white" }} htmlFor="subject4">
            المقرر الثامن
          </label>
          <select
            style={{ marginBottom: "10px" }}
            className="form-control"
            id="subject8"
            onChange={(e) => setSubject8(e.target.value)}
            value={subject8}
          >
            <option value="">-- اختر المادة --</option>
            {documents
              ?.filter(
                (course) =>
                  course.course_id !== subject1 &&
                  course.course_id !== subject2 &&
                  course.course_id !== subject3 &&
                  course.course_id !== subject5 &&
                  course.course_id !== subject6 &&
                  course.course_id !== subject7
              )
              .map((course) => {
                return (
                  <option key={course.course_id} value={course.course_id}>
                    {course.course_title} | {course.course_id}
                  </option>
                );
              })}
          </select>
          </Col>
          <Col sm={3} xs={3} md={2} style={{margin:' auto', marginTop: '41px'}}>
          {subject8 && !student?.[0]?.failed_subjects?.includes(subject8) && (
                <Button className="w-100" onClick={() => setSubject8("")} size="sm" variant="danger"> 
                    <MdDeleteForever/>  
                </Button>
            )}
          </Col>
          </Row>
        </div>
         <div className="form-group">
            <label style={{ marginBottom: "12px", color:"white" }} htmlFor="notes">
            الملاحظات (اختياري)
            </label>
            <textarea
              className="form-control"
              id="notes"
              onChange={(e) => setNotes(e.target.value)}
              value={notes}
              placeholder="اكتب ملاحظة للمرشد, مثال: ضرورة مقابلة المرشد, مادة غير مكمل, يوجد مادة بالمراجعة.."
            />

          </div>

    
        <Button style={{marginTop: '1.5rem'}} disabled={!subject1 && !subject2 && !subject3 && !subject4 && !subject5 && !subject6 && !subject7 && !subject8 && !notes} type="submit" variant="dark">
          ارسال
        </Button>
      </Form>

      </Card.Body>
    </Card>
    

    <Modal className='comment-modal' show={confirmationModal} onHide={() => setConfirmationModal(false)}>
        <Modal.Header>
          <Modal.Title> الرجاء التأكيد</Modal.Title>
        </Modal.Header>
        <Modal.Body>   
             هل انت متأكد من تسجيل المواد التالية :  <br/>
           {finalSubjects.join(', ')} <br/> 
         {notes && `ملاحظة : ${notes}`}
       </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setConfirmationModal(false)}>
            إلغاء 
          </Button>
          <Button variant="light"  onClick={() => setConfirm(true)}>
            نعم 
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
